import { createActionGroup, props } from '@ngrx/store';
import { CountryEntity } from './country.entity';
import { CountryModel } from '@core/data-access';

export type CountryInitProps = {
  countries: CountryModel[];
};

export type CountryLoadSuccessProps = {
  entities: CountryEntity[];
};

export const CountryActions = createActionGroup({
  source: 'Country',
  events: {
    Init: props<CountryInitProps>(),
    'Load Success': props<CountryLoadSuccessProps>(),
    'Load Failure': props<{ error: any }>(),
  },
});
